import {AxiosInstance} from "axios";
import PriorityRepositoryInterface from "@/services/Bug-report/Settings/interfaces/priority.repository";
import {CreatePriorityDTO, UpdatePriorityDTO} from "@fenix/bug-report-entities/bug-report-entities";
import {PriorityEntity} from "@fenix/bug-report-entities/bug-report-entities";

export default class PriorityRepository implements PriorityRepositoryInterface {
  constructor(private readonly axios: AxiosInstance) {}

  async create(DTOs: CreatePriorityDTO[]): Promise<PriorityEntity[]> {
    const url = 'bug-report/bugs/priority';

    const res = await this.axios.post(url, DTOs);
    return res.data;
  }

  async getOne(id: number, relations?: string[]): Promise<PriorityEntity> {
    const url = `bug-report/bugs/priority/${id}${relations && relations?.length ? `?relations=${relations.toString()}` : ''}`;

    const res = await this.axios.get(url);
    return res.data;
  }

  async updateOne(id: number, dto: UpdatePriorityDTO): Promise<PriorityEntity> {
    const url = `bug-report/bugs/priority/${id}`;

    const res = await this.axios.patch(url, dto);
    return res.data;
  }

  async deleteOne(id: number): Promise<void> {
    const url = `bug-report/bugs/priority/${id}`;
    const res = await this.axios.delete(url);

    return res.data;
  }

  async getAll(page?: number, take?: number): Promise<PriorityEntity[]> {
    const url = `bug-report/bugs/priority?page=${page ?? ''}&take=${take ?? ''}`;

    const res = await this.axios.get(url);
    return res.data;
  }
}
